/* import __COLOCATED_TEMPLATE__ from './tile.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type { EntityType } from 'embercom/models/data/entity-types';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    id: string;
    title: string;
    description?: string;
    iconOnlyEntityType?: boolean;
    entityType: EntityType;
    onClick: () => void;
    sourceIconUrl?: string;
    icon?: InterfaceIconName;
    titleSize: '1' | '2' | '3' | '4';
    copilotOnly?: boolean;
  };
}

export default class Tile extends Component<Signature> {
  @service declare appService: AppService;

  get shouldUseContentSetupV2() {
    return this.appService.app.canUseUnifiedContentUI;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::SetupModal::Tile': typeof Tile;
    'knowledge-hub/filterable-list/setup-modal/tile': typeof Tile;
  }
}
